module.exports = __webpack_public_path__ + "images/emoji/couplekiss.8369392556192f5a519b.png";